import { UserUploadPhotos } from '@app/application/components/upload/UserUploadPhotos';

export const UploadPhotosPage = () => {
  return <UserUploadPhotos />;
};
